import axios from 'axios'
import qs from 'qs'
import { Message } from 'element-ui'
import { getToken,removeToken } from '@/utils/auth'
import { setStore, removeStore } from '@/utils/index'
import {getApiUrl} from '@/utils/apiUrlConfig.js'
import router from '@/router'
import {Loading} from "element-ui"

function fileTime(){
  var formatNumber=function(n){
    n = n.toString()
    return n[1] ? n : `0${n}`
  }
  const date=new Date();
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return `${[year, month, day].map(formatNumber).join('')}_${[hour, minute, second].map(formatNumber).join('')}`

}
/**
* 判断变量是否为空，
* @param  {[type]}  param 变量
* @return {Boolean}      为空返回true，否则返回false。
*/
function isEmpty(param){
   if(param){
       var param_type = typeof(param);
       if(param_type == 'object'){
           //要判断的是【对象】或【数组】或【null】等
           if(typeof(param.length) == 'undefined'){
               if(JSON.stringify(param) == "{}"){
                   return true;//空值，空对象
               }
           }else if(param.length == 0){
               return true;//空值，空数组
           }
       }else if(param_type == 'string'){
           //如果要过滤空格等字符
           var new_param = param.trim();
           if(new_param.length == 0){
               //空值，例如:带有空格的字符串" "。
               return true;
           }
       }else if(param_type == 'boolean'){
           if(!param){
               return true;
           }
       }else if(param_type== 'number'){
           if(!param){
               return true;
           }
       }
       return false;//非空值
   }else{
       //空值,例如：
       //(1)null
       //(2)可能使用了js的内置的名称，例如：var name=[],这个打印类型是字符串类型。
       //(3)空字符串''、""。
       //(4)数字0、00等，如果可以只输入0，则需要另外判断。
       if(param==0){
         return false
       }else{
        return true;
       }
   }
}

function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}


let axiosIns = axios.create()

export let method = {
  get: 'get',
  post: 'post',
  options: 'options',
  put: 'put',
  patch: 'patch',
  delete: 'delete',
  head: 'head'
}
const getUrlencodedBody=(arg)=>{
  return qs.stringify(arg);
}
const service= (service0pt)=> {
  const type = method[service0pt.method].toLowerCase();
  Loading.service({ fullscreen: true,background:"rgba(0,0,0,0)" });
  if(isArray(service0pt.params)){
    var params=service0pt.params;
  }else{
    var params={};
    for(let key in service0pt.params){
      if(!isEmpty(service0pt.params[key])){
        params[key]=service0pt.params[key];
      }
    }
  }
  let opt = {
    params: params,
    headers: {},
    success: function () {
    },
    error: function () {
    },
    finally: function () {
    }
  }
  let passData = type === method.put || type === method.post || type === method.patch
  return new Promise((resolve, reject) => {
    let headers = opt.headers
    if(service0pt.dataType=='urlencoded'){
      opt.params=getUrlencodedBody(opt.params);
    }
    if(service0pt.dataType=='file'){
      opt.responseType='arraybuffer'
    }
    if(service0pt.dataType=='formDatafile'){
      opt.responseType='arraybuffer'
      opt.params=getUrlencodedBody(opt.params);
    }
    if(service0pt.dataType=='image'){
      opt.responseType='blob'
    }
    if(service0pt.contentType){
      headers['Content-Type']=service0pt.contentType;
    }
    if(service0pt.contentType=="multipart/form-data"){
      opt.params=service0pt.params
    }
    if (headers['x-auth-token'] === undefined) {
      headers['x-auth-token'] = getToken()
    }
    setStore('x-auth-token', headers['token'], 24 * 60 * 60)  // 更新 登录 token过期时间
    axiosIns({
      baseURL: process.env.BASE_API || process.env.DEFAULT_BASE_API,
      url: service0pt.url,
      params: passData ? '' : opt.params,
      data: passData ? opt.params : '',
      responseType: opt.responseType ? opt.responseType : 'json',
      method: type,
      headers: headers,
      //默认30秒超时
      timeout: opt.timeout || 60 * 1000 * 3
    }).then( (res)=> {
      Loading.service({ fullscreen: true,background:"rgba(0,0,0,0)" }).close();
      // console.log(`${service0pt.url}请求结果`,service0pt,res)
      // 返回文件流类型
      if(service0pt.dataType=='file'||service0pt.dataType=='formDatafile'){
        let time =fileTime()
        let blob = new Blob([res.data], {type: 'application/octet-stream'})
        let objectUrl = URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href =  objectUrl
        const SpaceName = localStorage.getItem('space-info') ? JSON.parse(localStorage.getItem('space-info')).name+"_" : '';
        let fn = service0pt.fileName?SpaceName+service0pt.fileName+"_"+time:SpaceName+time;
        if(service0pt.extension){
          link.download =  fn + '.'+service0pt.extension
        }else{
          link.download =  fn + '.xls'
        }
        document.getElementsByTagName('body')[0].appendChild(link).click()
        resolve(res.data)
        return
      }else if(service0pt.dataType=='image'){
        resolve(res.data)
        return
      }
      if (res.data.success) {
        resolve(res.data)
      } else {
        const needLoginCode=[401,103];
        if (needLoginCode.includes(res.data.code)) {
          removeStore('x-auth-token')
          removeToken('x-auth-token')
          removeStore('x_access_username')
          Message({
            duration:5000,
            type: 'error',
            message: res.data.msg
          })
          router.replace({name: 'Login'})
        } else {
          if(!service0pt.noTip){
            Message({
              duration:5000,
              type: 'error',
              message: res.data.msg
            })
          }
          reject(res)
        }
      }
    }).catch(function (err) {
      Loading.service({ fullscreen: true,background:"rgba(0,0,0,0)" }).close();
      console.log('err: ', err)
      if (err && err.response) {
        switch (err.response.status) {
          case 400:
            err.message = '错误请求'
            break
          case 401:
            err.message = '登录已过期，请重新登录'
            break
          case 403:
            err.message = '拒绝访问'
            break
          case 404:
            err.message = '请求错误,未找到该资源'
            break
          case 405:
            err.message = '请求方法未允许'
            break
          case 408:
            err.message = '请求超时'
            break
          case 500:
            err.message = '服务器端出错'
            break
          case 501:
            err.message = '网络未实现'
            break
          case 502:
            err.message = '网络错误'
            break
          case 503:
            err.message = '服务不可用'
            break
          case 504:
            err.message = '网络超时'
            break
          case 505:
            err.message = 'http版本不支持该请求'
            break
          default:
            err.message = `连接错误${err.response.status}`
        }
      } else {
        err.message = '请求超时，操作失败，请检查网络后再试！'
      }
      Message({
        duration:5000,
        type: 'error',
        message: err.message
      })
      const needLogin=[401];
      if(needLogin.includes(err.response.status)){
        removeStore('x-auth-token')
        removeToken('x-auth-token')
        removeStore('x_access_username')
        router.replace({name: 'Login'})
      }
      reject(err.response)
    }).finally(function () {

    })
  })
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js